import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { notification } from '../store/actions';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { scroller, Element } from 'react-scroll';

const Error = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 23px;
  color: white;
`;

const ErrorWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: #a83569;
  color: white;
  padding: 16px 40px 16px 16px;
  margin-bottom: 25px;

  .close-icon {
    position: absolute;
    right: 25px;
    top: 17px;
    z-index: 999;
    font-size: 16px;
    cursor: pointer;
  }
`;

function ShowClientErrors({ error, scroll, className }) {
  useEffect(() => {
    if (scroll) {
      scroller.scrollTo(`error-${error}`, {
        duration: 800,
        delay: 0,
        smooth: 'easeInOutQuart',
        offset: -110
      });
    }
  }, [error]);

  return (
    <Element name={`error-${error}`} className="element">
      <ErrorWrapper className={`error-wrapper ${className}`}>
        <Error>{error}</Error>
      </ErrorWrapper>
    </Element>
  );
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({
  onNotification: (message, type) => {
    dispatch(notification({ message, type }));
  }
});

const connecter = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default connecter(ShowClientErrors);
